'use client';

import dynamic from 'next/dynamic';

const DistanceMap = dynamic(() => import('./DistanceMap'), {
  ssr: false,
});

export default DistanceMap;
